import { Typography } from '@mui/material';
import { t } from 'i18next';

/**Create and return the moveOptions Object necessary for the Move Ownership view to work.
 * @param {string} userId A User ID for the "From" of the Move Ownership functionality.
 */
const useMoveOptions = (userId) => {
    /**An Object containing a set of functions and values necessary for the Move Ownership view. */
    const moveOptions = {
        dataKey: 'UserID',
        label1: 'Selected User',
        label2: 'Search for Destination User',
        description1: `Below is the user you have chosen to have their student’s moved to another user.`,
        description2:
            'Below is a list of possible user matches based on your selected user’s name.  If you do not see the user you wish to the above users’ student(s) to listed below, you can start a new search.  Type the last name, first name, or username into the search box to start a fresh search.   Once you have  located the correct user you can select the user using the radio button and click Move Records.  This will append all application data, documents, history, annual statements, and invoices for the student’s listed above to the user you have selected.  The user you select below will gain access to the students and all associated data. ',
        moveViewTitle: 'Move Student Records',
        inputPlaceholder: t('MoveRecord.Application.SearchPlaceholder'),
        possibleMatchesLanguage: t('MoveRecord.Application.PossibleMatches'),
        getURL: () => `/usersettings/${userId}/move_candidates`,
        updateURL: () => `/usersettings/${userId}/move`,
        buildBody: (target, toRecord) => {
            return {
                AppInstIDs: target.AppInstIDs,
                ToUserID: toRecord.UserID,
            };
        },
        buildComparison: (target, toRecord, modalContentList) => {
            return (
                <ul>
                    {target?.Students?.map((student, i) => (
                        <>
                            <li style={modalContentList}>
                                Move student {student}’s ({target?.UniqueIDs[i]}) applications to user {toRecord?.Username}?{' '}
                            </li>
                            <ul>
                                {target?.appInfo[i]?.map((app) => {
                                    return (
                                        <li style={{ listStyleType: 'disc' }}>
                                            {app['Term Description']} {app?.ApplicationType}
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
                    ))}
                </ul>
            );
        },
        cancelText: 'No, Cancel Move',
        confirmText: 'Yes, Move Records',
        modalTitle: 'Do you want to complete the move?',
        renderModalContent: () => {
            return null;
        },
        buildConfirmDescription: (target, toRecord, modalContentOverride) => {
            return (
                <>
                    <Typography sx={{ fontWeight: 700, color: (theme) => theme.palette.error.main, fontSize: 20 }}>WARNING:</Typography>
                    <Typography sx={modalContentOverride}>
                        The action you are about to take is final and cannot be undone. Are you sure you want to move all student(s) and
                        their associated application data from Username {target?.Username} to Username {toRecord?.Username}?
                    </Typography>
                </>
            );
        },
        sort: null,
    };

    return moveOptions;
};

export default useMoveOptions;
